<script>
    import {fade, fly} from 'svelte/transition';
    import Footer from './footer.svelte';
    let visible = false;
    let visiblePart2 = false;
    let visiblePart3 = false;
    const listItem = [
        'Sold their companies for multiple millions',
        'Featured in Forbes 30 under 30',
        'Currently funded by some of the most prestigious investors',
    ];
    const cardsImg = [
        'images/ecosystem_section/ecosystem_img1.png',
        'images/ecosystem_section/ecosystem_img2.png',
        'images/ecosystem_section/ecosystem_img3.png',
        'images/ecosystem_section/ecosystem_img4.png',
        'images/ecosystem_section/ecosystem_img5.png',
        'images/ecosystem_section/ecosystem_img6a.png',
    ];
    let element;
    let distanceFromTop;
    let distance;
    export let scrollY;
    export let viewPortHeight;
    $: {
        if (element) {
            distanceFromTop = element.offsetTop - viewPortHeight / 2;
        }
    }
    $: {
        distance = scrollY - distanceFromTop;
        if (distance > 0) {
            if (distance > 100) visible = true;
            if (distance > 200) visiblePart2 = true;
            if (distance > 300) visiblePart3 = true;
        }
    }
    // $: console.log('scrollY', scrollY);
    // $: console.log('distanceFromTop', distanceFromTop);
    // $: console.log("distance", distance);
</script>

<div class="ecosystem_class desktop" bind:this={element}>
    {#if visible}
        <div in:fly={{y: 200, duration: 2000}} out:fade>
            <div class="main-heading">
                <p>Our Ecosystem.</p>
            </div>
            <div class="main-text">
                <p>
                    A unique approach for connecting talents, experts and
                    investors together by providing champion facilitators and an
                    unparalleled network of mentors, industry experts, corporate
                    partners and investors to support the innovation ecosystem
                    throughout the lifecycle of the innovation hub.
                </p>
            </div>
            <div class="network">
                <p class="network">
                    <a
                        href="/about_us"
                        style="
    color: #00204b;"
                    >
                        Get to know our network
                    </a>
                </p>
            </div>
        </div>
    {/if}
    {#if visiblePart2}
        <div class="animation-part2">
            <div class="ani2" />
            <div class="logos">
                <div class="logo-imgs">
                    <div class="three-images">
                        <div class="img-heading-body">
                            <img
                                src="images/ecosystem_section/draper_startup_house_Logo.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="img-heading-body">
                            <img
                                src="/images/ecosystem_section/draper_hero_city_Logo.svg"
                                alt=""
                                width="100%"
                                style="
    height: 4vw;
    margin-top: 0.7vw;
"
                            />
                        </div>
                        <div class="img-heading-body">
                            <img
                                src="images/ecosystem_section/draper_hero_institue_Logo.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                    </div>
                    <div class="first-two-images">
                        <div class="img-heading-body-center">
                            <img
                                src="/images/ecosystem_section/draper_university_Logo.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="img-heading-body-center">
                            <img
                                src="/images/ecosystem_section/DUV_Logo.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                    </div>
                    <div class="last-two-images">
                        <div class="img-heading-body ">
                            <img
                                src="/images/ecosystem_section/draper_hero_hangout_Logo.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="img-heading-body">
                            <img
                                src="/images/ecosystem_section/draper_venture_network_Logo.svg"
                                alt=""
                                width="100%"
                                style="height: 6vw;width:6vw"
                            />
                        </div>
                    </div>
                </div>
                <div class="rectangles">
                    <div class="rectangle1">
                        <img
                            src="/images/ecosystem_section/rectangle_img1.png"
                            alt=""
                        />
                    </div>
                    <div class="rectangle2">
                        <img
                            src="/images/ecosystem_section/rectangle_img2.png"
                            alt=""
                        />
                    </div>
                    <div class="rectangle3">
                        <img
                            src="/images/ecosystem_section/rectangle_img3.png"
                            alt=""
                        />
                    </div>
                </div>
                <div class="rectangle-text">
                    <div class="text1"><p>Explore</p></div>
                    <div class="text2"><p>Accelerate</p></div>
                    <div class="text3"><p>Grow</p></div>
                </div>
            </div>
        </div>
    {/if}
    {#if visiblePart3}
        <div in:fly={{y: 500, duration: 2000}} out:fade>
            <div class="text-with-pic">
                <div class="text">
                    <div class="main-text">
                        <p>
                            "We are a collective of people who can achieve
                            anything."
                        </p>
                    </div>
                    <div class="body-text">
                        <p>
                            A network of over<mark class="marker">
                                1000 heroes</mark
                            >
                            from ov<mark class="marker">er 90 countries</mark> who
                            have
                        </p>
                    </div>
                    <div class="list-class">
                        {#each listItem as items}
                            <div class="text-list">
                                <!-- <div class="list-icon">
                                    <img src={list_icon} alt="" />
                                </div> -->
                                <div class="text"><p>{items}</p></div>
                            </div>
                        {/each}
                    </div>
                </div>
                <div class="pic">
                    <div class="cards">
                        {#each cardsImg as card}
                            <div class="card-layout">
                                <div class="card-icon">
                                    <img src={card} alt="" />
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>
<div class="mobile">
    <div style="margin:5vw 0vw;">
        <h1 class="our-eco">Our Ecosystem.</h1>
        <div style="padding: 5vw;">
            <p class="eco-desci">
                A unique approach for connecting talents, experts and investors
                together by providing champion facilitators and an unparalleled
                network of mentors, industry experts, corporate partners and
                investors to support the innovation ecosystem throughout the
                lifecycle of the innovation hub.
            </p>
        </div>
        <div>
            <p class="network">
                <a
                    href="/about_us"
                    style="color: #00204b;"
                >
                    Get to know our network
                </a>
            </p>
        </div>
        <div style="margin: 5vw;">
            <div style="display:flex;gap:3vw;">
                <div style="">
                    <div class="mobile_eco_logos" style="width:16vw;height:15vw;">
                        <img
                            src="images/ecosystem_section/draper_startup_house_Logo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div style="">
                    <div class="mobile_eco_logos" style="width:10vw;height:15vw;">
                        <img
                            src="images/ecosystem_section/draper_hero_city_Logo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div style="">
                    <div class="mobile_eco_logos" style="width:14vw;height:15vw;">
                        <img
                            src="images/ecosystem_section/draper_hero_institue_Logo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div class="bar_align">
                <div class="exp" />
                <h1>Explore</h1>
            </div>
            <div style="display:flex;gap:3vw;">
                <div style="">
                    <div class="mobile_eco_logos" style="width:15vw;height:17vw;">
                        <img
                            src="images/ecosystem_section/draper_university_Logo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div style="">
                    <div class="mobile_eco_logos" style="width:11vw;height:17vw;">
                        <img
                            src="images/ecosystem_section/DUV_Logo.svg"
                            alt=""
                            width="90%"
                        />
                    </div>
                </div>
            </div>
            <div class="bar_align">
                <div class="accel" />
                <h1>Accelerate</h1>
            </div>
            <div style="display: flex;gap:3vw;">
                <div style="">
                    <div class="mobile_eco_logos" style="width:17vw;height:15vw;">
                        <img
                            src="images/ecosystem_section/draper_hero_hangout_Logo.svg"
                            alt=""
                            width="90%"
                        />
                    </div>
                </div>
                <div style="">
                    <div class="mobile_eco_logos" style="width:20vw;height:15vw;">
                        <img
                            src="/images/ecosystem_section/draper_venture_network_Logo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div class="bar_align">
                <div class="grow" />
                <h1>Grow</h1>
            </div>
            <hr />
            <div>
                <h1
                    style="font-weight: 600;font-size:4.271vw;line-height:4.673vw;text-align: center;color: #00204B;"
                >
                    “We are a collective of people who can achieve anything.”
                </h1>
                <p
                    style="font-size: 2.7vw;line-height:6vw;color: #00204B;padding-left:5vw;"
                >
                    A network of over <b
                        >1<span class="marker">000 hero</span>es</b
                    >
                    from over
                    <b>90 co<span class="marker">untries w</span></b>ho have
                </p>
                <ul class="d-flex justify-content-between">
                    <li>
                        <p>Sold their companies for multiple millions.</p>
                    </li>
                    <li>
                        <p>Featured in Forbes 30 under 30</p>
                    </li>
                    <li>
                        <p>
                            Currently funded by some of the most prestigious
                            investors.
                        </p>
                    </li>
                </ul>
                <div style="width: 82vw;margin:auto">
                    <div class="cards-mobile">
                        {#each cardsImg as card}
                            <div class="card-layout-mobile">
                                <img
                                    src={card}
                                    alt=""
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<Footer />

<style>
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
    }
    .cards-mobile {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        gap: 5.35vw;
        margin-left: 1vw;
    }
    .card-layout-mobile {
        border-radius: 2.323vw;
        width: 22.8125vw;
        height: 22.8125vw;
        box-shadow: 0vw 0.467vw 1.869vw rgba(0, 0, 0, 0.25);
    }
    ul li::marker {
        color: #7cc1ff;
    }
    ul li {
        font-size: 2.1vw;
        line-height: 2.804vw;
        width: 24vw;
        color: #00204b;
    }
    .bar_align {
        display: flex;
        margin-bottom: 6vw;
    }
    .bar_align h1 {
        font-size: 3.271vw;
        padding-left: 2vw;
        font-weight: 800;
    }
    .exp {
        width: 49.065vw;
        height: 3.972vw;
        background: linear-gradient(270deg, #8abce6 0%, #f7e05f 100%);
        border-radius: 0 2vw 2vw 0;
    }
    .accel {
        width: 60.047vw;
        height: 3.972vw;
        background: linear-gradient(270deg, #76a2dd 0%, #f7e05f 97.54%);
        border-radius: 0 2vw 2vw 0;
    }
    .grow {
        width: 80.607vw;
        height: 3.972vw;
        background: linear-gradient(270deg, #6389bc 0%, #f7e05f 100%);
        border-radius: 0 2vw 2vw 0;
    }
    .our-eco {
        font-size: 5.607vw;
        text-align: center;
        font-weight: 800;
        color: rgba(0, 32, 75, 1);
    }
    .eco-desci {
        text-align: center;
        font-size: 2.804vw;
        color: rgba(0, 32, 75, 0.8);
    }
    .ecosystem_class {
        min-height: 50vw;
        font-family: "Inter";
        margin-top: 9.061vw;
    }
    .network {
        color: rgba(0, 32, 75, 1);
        font-size: 3.271vw;
        text-align: center;
        text-decoration: underline;
    }
    .main-heading {
        display: flex;
        margin: auto;
        justify-content: center;
    }
    .main-heading p {
        color: #00204b;
        font-style: normal;
        font-weight: 600;
        font-size: 3.968vw;
    }
    .main-text {
        padding-top: 2.083vw;
        display: flex;
        margin: auto;
        justify-content: center;
        width: 75.926vw;
    }
    .main-text p {
        font-size: 1.323vw;
        text-align: center;
        font-weight: 300;
        color: #00204bcc;
    }
    .network {
        display: flex;
        margin: auto;
        margin-top: 0.484vw;
        justify-content: center;
    }
    .network p {
        font-size: 1.323vw;
        font-weight: 400;
        text-decoration: underline;
        color: #00204b;
    }
    .logos {
        margin-top: 5.093vw;
    }
    .logo-imgs {
        display: flex;
        margin: auto;
        width: 71.5%;
    }
    .logo-imgs img {
        height: 2.5vw;
        width: 2.5vw;
    }
    .img-heading-body img {
        width: 4.726vw;
        height: 5.832vw;
    }
    .img-heading-body-center img {
        width: 9.263vw;
        height: 7vw;
    }
    .logo-imgs .first-two-images {
        width: 35.697900000000004vw;
        height: 5.989vw;
        display: flex;
        justify-content: center;
        margin: auto;
        margin-bottom: -0.5vw;
    }
    .logo-imgs .three-images {
        width: 35.697900000000004vw;
        height: 5.989vw;
        justify-content: center;
        margin: auto;
        display: flex;
        gap: 1vw;
        margin-bottom: -2.5vw;
    }
    .logo-imgs .last-two-images {
        width: 35.697900000000004vw;
        height: 5.989vw;
        justify-content: center;
        margin: auto;
        display: flex;
        gap: 3vw;
        margin-bottom: -2.5vw;
    }
    .rectangles {
        width: 95%;
        display: flex;
        flex-direction: row;
        gap: 0;
        justify-content: center;
        margin: auto;
        margin-top: 3vw;
    }
    .rectangle1 img {
        width: 23.6979vw;
        height: 1.71875vw;
    }
    .rectangle2 img {
        width: 23.6979vw;
        height: 1.71875vw;
    }
    .rectangle3 img {
        width: 23.6979vw;
        height: 1.71875vw;
    }
    .rectangle-text {
        padding-top: 1.1979vw;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: auto;
    }
    .rectangle-text .text1 {
        float: left;
        width: 23.6979vw;
    }
    .rectangle-text .text2 {
        float: left;
        width: 23.6979vw;
    }
    .rectangle-text .text3 {
        float: left;
        width: 23.6979vw;
    }
    .rectangle-text p {
        color: #00204b;
        font-weight: 700;
        font-size: 1.653vw;
    }
    .animation-part2 {
        position: relative;
        overflow: hidden;
    }
    @keyframes slideInFromLeft {
        0% {
            left: 0;
        }
        100% {
            left: 90vw;
        }
    }
    .ani2 {
        width: 100%;
        height: 20vw;
        background-color: white;
        position: absolute;
        top: 0;
        animation-name: slideInFromLeft;
        animation-duration: 3s;
        animation-iteration-count: 1;
        animation-direction: alternate;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
    }
    .text-with-pic {
        padding-top: 7.937vw;
        display: flex;
        justify-content: center;
        margin: auto;
        flex-direction: row;
        margin-bottom: 10.5729vw;
    }
    .text-with-pic .text {
        width: 50%;
    }
    .text-with-pic .text .main-text {
        width: 35.251vw;
        height: fit-content;
        margin-left: 18vw;
    }
    .text-with-pic .text .main-text p {
        font-size: 1.984vw;
        color: #00204b;
        font-weight: 600;
        text-align: start;
    }
    .text-with-pic .text .body-text {
        padding-left: 18.5vw;
        padding-top: 1.307vw;
    }
    .text-with-pic .text .body-text p {
        font-size: 0.926vw;
        color: #00204b;
    }
    .text-with-pic .pic {
        float: left;
        width: 50%;
    }
    .text-with-pic .text .body-text p mark {
        background-color: #ffee90eb;
        border-radius: 1vw;
        font-weight: bold;
    }
    .list-class {
        width: 120%;
    }
    .text-with-pic .text-list {
        display: flex;
        flex-direction: row;
        gap: 0.5vw;
        padding-left: 19.5vw;
    }
    .text-with-pic .text-list p {
        display: flex;
        font-size: 0.926vw;
        width: 23.545vw;
        font-weight: 400;
        font-style: italic;
    }
    .cards {
        width: 30vw;
        margin-left: 8.28125vw;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        gap: 1.35vw;
    }
    .card-layout {
        border-radius: 1.323vw;
        width: 7.8125vw;
        height: 7.8125vw;
    }
    .card-layout img {
        width: 7.8125vw;
        height: 7.8125vw;
    }
</style>
